function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ClickContainer from 'shared/components/ClickContainer';
import LanguageToggle from 'shared/components/LanguageToggle';
import Link from 'shared/components/Link';
import featureEnabled from 'shared/helper/feature';
import { T, useTranslate } from 'shared/helper/translate';
import { getApiBaseUrl } from 'shared/helper/request';
import pngLogoImage from '../images/localized/aje-current-logo-rgb-no-clear-space.png';
import svgLogoImage from '../images/rubriq-logo-rgb-color-light-32x119.jpg';
import qrCode from '../images/localized/qr-code2.png';
import qrIcon from '../images/localized/qricon.png';
import ColumnOfLinks from './frontendNavbar/ColumnOfLinks';
import Logo from './Logo';
import MobileNav from './frontendNavbar/MobileNav';
import LegacyLoginDropdown from './LoginDropdown';
import GroupedLoginDropdown from './frontendNavbar/GroupedLoginDropdown';
import NavbarTrialStatus from './NavbarTrialStatus';
var HeaderChina = function HeaderChina(_ref) {
  var digitalTranslationsEnabled = _ref.digitalTranslationsEnabled,
    headerLinks = _ref.headerLinks,
    path = _ref.path,
    siteLanguage = _ref.siteLanguage,
    siteLanguages = _ref.siteLanguages,
    translationContext = _ref.translationContext,
    updateSiteLanguage = _ref.updateSiteLanguage,
    user = _ref.user,
    website = _ref.website;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    displayedDropdown = _useState2[0],
    setDisplayedDropdown = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showMobileMenu = _useState4[0],
    setShowMobileMenu = _useState4[1];
  var location = useLocation();
  var showCurie = featureEnabled('curie_is_launched');
  var useGroupedNavigation = featureEnabled('grouped_navigation_menu') || showCurie;
  var LoginDropdown = useGroupedNavigation ? GroupedLoginDropdown : LegacyLoginDropdown;
  var urlParams = new URLSearchParams(location.search);
  var existingRedirect = urlParams.get('redirect');
  var redirectPath = existingRedirect || "".concat(location.pathname).concat(location.search);
  var userName = (user === null || user === void 0 ? void 0 : user.firstName) || (user === null || user === void 0 ? void 0 : user.fullName);
  var dismissDropdowns = function dismissDropdowns() {
    setDisplayedDropdown('');
  };
  var toggleDropdown = function toggleDropdown(title) {
    setDisplayedDropdown(function (prevTitle) {
      return prevTitle === title ? '' : title;
    });
  };
  var account = headerLinks.account,
    additionalServices = headerLinks.additionalServices,
    automatedTools = headerLinks.automatedTools,
    professionalEditing = headerLinks.professionalEditing,
    allServices = headerLinks.allServices;
  useEffect(function () {
    if (digitalTranslationsEnabled) {
      account.links.splice(5, 0, {
        icon: '',
        text: 'My Digital Translations',
        url: 'researcher/digital-translations'
      });
    }
  }, [digitalTranslationsEnabled]);
  return /*#__PURE__*/React.createElement(ClickContainer, {
    id: "frontend-nav",
    className: "navbar navbar-light rubriq-nav fixed-top",
    onClickOutside: dismissDropdowns,
    onMouseLeave: dismissDropdowns
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "navbar navbar-expand-lg w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none d-flex justify-content-end w-100"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Menu'),
    className: "nav-button mobile-nav-button nav-item d-inline navbar-toggler mt-3",
    id: "mobile-menu-button",
    onClick: function onClick() {
      return setShowMobileMenu(!showMobileMenu);
    },
    type: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Menu"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "mobile-menu",
    className: "".concat(showMobileMenu ? 'show' : 'hide', " d-lg-none")
  }, /*#__PURE__*/React.createElement(MobileNav, {
    siteLanguage: siteLanguage,
    siteLanguages: siteLanguages,
    displayedDropdown: displayedDropdown,
    chinaLocalization: true,
    path: path,
    userName: userName,
    updateSiteLanguage: updateSiteLanguage,
    translationContext: translationContext,
    user: user,
    toggleDropdown: toggleDropdown,
    headerLinks: headerLinks,
    setShowMobileMenu: setShowMobileMenu,
    showCurie: showCurie,
    useGroupedNavigation: useGroupedNavigation
  })), /*#__PURE__*/React.createElement("div", {
    className: "navbar-header rubriq-header d-none d-lg-block"
  }, /*#__PURE__*/React.createElement("div", {
    id: "nav-top-collapse",
    className: "collapse rubriq-sub-nav navbar-collapse dont-collapse-sm d-flex-row justify-content-around"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "navbar-nav navbar-expand-md mb-1 d-flex align-items-center",
    id: "left-nav",
    role: "menubar"
  }, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, user.loggedIn ? /*#__PURE__*/React.createElement(Link, {
    className: "navbar-brand navbar-logo float-start",
    to: "/"
  }, /*#__PURE__*/React.createElement(Logo, {
    className: "header-brand-logo",
    fallbackImage: pngLogoImage,
    image: svgLogoImage
  })) : /*#__PURE__*/React.createElement("a", {
    className: "navbar-brand navbar-logo float-start",
    href: "https://".concat(website),
    "aria-label": t('my-aje')
  }, /*#__PURE__*/React.createElement(Logo, {
    className: "header-brand-logo",
    fallbackImage: pngLogoImage,
    image: svgLogoImage
  }))), /*#__PURE__*/React.createElement("li", {
    "aria-label": t('Workspace'),
    className: "nav-item ",
    role: "menuitem",
    style: {
      paddingRight: '16px'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Workspace'),
    className: "nav-link nav-dropdown",
    type: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Workspace"
  })))), /*#__PURE__*/React.createElement("li", {
    "aria-label": t('Pricing'),
    className: "nav-item ",
    role: "menuitem",
    style: {
      paddingRight: '16px'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/plan"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Pricing'),
    className: "nav-link nav-dropdown",
    type: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.pricing"
  })))), /*#__PURE__*/React.createElement("li", {
    "aria-label": t('Payments'),
    className: "nav-item right-nav",
    role: "menuitem",
    style: {
      paddingRight: '16px'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/researcher/invoices"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Payments'),
    className: "nav-link nav-dropdown",
    type: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Payments"
  })))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item dropdown has-megamenu ".concat(displayedDropdown === 'services' ? 'show' : ''),
    role: "menuitem"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-expanded": "false",
    "aria-label": t('Services'),
    className: "nav-link dropdown-toggle nav-dropdown",
    href: "#",
    onClick: function onClick() {
      return toggleDropdown('services');
    },
    onMouseEnter: function onMouseEnter() {
      return toggleDropdown('services');
    },
    type: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Services"
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "xs",
    icon: "fa-chevron-down"
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu megamenu-china-navbar ".concat(displayedDropdown === 'services' ? 'show' : ''),
    role: "menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row china-megamenu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col professionalEditing"
  }, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: professionalEditing.title,
    links: professionalEditing.links,
    siteLanguage: siteLanguage
  })), /*#__PURE__*/React.createElement("div", {
    className: "col authoringServices"
  }, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: additionalServices.title,
    links: additionalServices.links,
    siteLanguage: siteLanguage
  })), /*#__PURE__*/React.createElement("div", {
    className: "col automatedTools"
  }, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: automatedTools.title,
    links: automatedTools.links,
    siteLanguage: siteLanguage
  })), /*#__PURE__*/React.createElement("div", {
    className: "all-services d-flex justify-content-center w-100"
  }, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    className: "bold-link",
    title: allServices.title,
    links: allServices.links,
    siteLanguage: siteLanguage
  })))))), /*#__PURE__*/React.createElement("ul", {
    className: "navbar-nav navbar-expand-md mb-1 ms-auto d-flex align-items-center",
    role: "menubar"
  }, /*#__PURE__*/React.createElement("li", {
    className: "has-megamenu me-3"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-phone"
  })), /*#__PURE__*/React.createElement("li", {
    className: "has-megamenu col me-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "row call"
  }, /*#__PURE__*/React.createElement(T, {
    source: "help line number"
  })), /*#__PURE__*/React.createElement("span", {
    className: "row call"
  }, /*#__PURE__*/React.createElement(T, {
    source: "call-timing"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "dropdown has-megamenu ".concat(displayedDropdown === 'qrcode' ? 'show' : ''),
    role: "menuitem"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-expanded": displayedDropdown === 'qrcode',
    "aria-label": t('qrcode'),
    className: "me-2",
    onClick: function onClick() {
      return toggleDropdown('qrcode');
    },
    onMouseEnter: function onMouseEnter() {
      return toggleDropdown('qrcode');
    },
    type: "button"
  }, /*#__PURE__*/React.createElement(Logo, {
    fallbackImage: pngLogoImage,
    image: qrIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu megamenu qrcode ".concat(displayedDropdown === 'qrcode' ? 'show' : ''),
    role: "menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "qrcode-text"
  }, /*#__PURE__*/React.createElement(T, {
    source: "qrcode-description"
  })), /*#__PURE__*/React.createElement(Logo, {
    fallbackImage: pngLogoImage,
    image: qrCode
  }))), /*#__PURE__*/React.createElement("li", {
    className: "list-inline-item ms-1"
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(getApiBaseUrl(), "/support"),
    className: "email-us",
    target: "_blank",
    "aria-label": t('Contact Us'),
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Contact Us"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item dropdown ".concat(displayedDropdown === 'loginDropdown' ? 'show' : ''),
    role: "menuitem"
  }, user !== null && user !== void 0 && user.loggedIn ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "nav-link dropdown-toggle nav-dropdown userAccount",
    href: "#",
    onClick: function onClick() {
      return toggleDropdown('loginDropdown');
    },
    "aria-expanded": "false"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "sm",
    icon: "fa-sharp-duotone fa-solid fa-user"
  }), /*#__PURE__*/React.createElement(T, {
    source: useGroupedNavigation ? 'my account' : 'Hello %s',
    params: userName.length > 12 ? '' : userName
  }), useGroupedNavigation ? '' : '!', /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "xs",
    icon: "fa-chevron-down"
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu ".concat(displayedDropdown === 'loginDropdown' ? 'show' : ''),
    role: "menu"
  }), /*#__PURE__*/React.createElement(LoginDropdown, {
    digitalTranslationsEnabled: digitalTranslationsEnabled,
    displayed: displayedDropdown === 'loginDropdown',
    onLinkClicked: function onLinkClicked() {
      return toggleDropdown('loginDropdown');
    },
    loggedIn: user.loggedIn,
    siteLanguage: siteLanguage,
    showCurie: showCurie
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Log In or Register'),
    "data-track": "click",
    "data-track-action": "button click",
    className: "btn-transparent",
    "data-track-label": "login or register",
    type: "button"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/".concat(siteLanguage, "/login?redirect=").concat(redirectPath),
    className: "log-in nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Log In or Register"
  }))))), (user === null || user === void 0 ? void 0 : user.loggedIn) && /*#__PURE__*/React.createElement(NavbarTrialStatus, null)), /*#__PURE__*/React.createElement("li", {
    className: "d-block d-sm-none mobile-language-links mx-0 border-bottom"
  }, siteLanguages.map(function (language) {
    return /*#__PURE__*/React.createElement(LanguageToggle, {
      className: "border-0 px-2 ".concat(siteLanguage === language.code ? 'current' : ''),
      key: language.code,
      language: language.code,
      path: path,
      updateSiteLanguage: updateSiteLanguage,
      translationContext: translationContext
    }, language.name);
  })))))));
};
export default HeaderChina;